import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, unref as _unref, withDirectives as _withDirectives, vShow as _vShow, withModifiers as _withModifiers, toDisplayString as _toDisplayString, mergeProps as _mergeProps, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue";
import _imports_0 from '../../../../../public/img/LeanLaw-Legal-payments.png';
const _hoisted_1 = {
  key: 0,
  class: "flex lg:flex-row sm:flex-col md:flex-col w-full"
};
const _hoisted_2 = {
  class: "lg:w-6/12 sm:w-full md:w-full px-4"
};
const _hoisted_3 = {
  class: "w-4/12 pb-2"
};
const _hoisted_4 = {
  key: 1,
  class: "pt-4 px-6 tw"
};
const _hoisted_5 = {
  class: "flex flex-row w-full h-full bg-white mb-4"
};
const _hoisted_6 = {
  class: "flex justify-between items-center pr-10 w-4/12"
};
const _hoisted_7 = {
  class: "w-6/12"
};
const _hoisted_8 = {
  class: "relative my-1 rounded-md shadow-sm print:hidden"
};
const _hoisted_9 = {
  class: "no-print pb-1 flex"
};
const _hoisted_10 = {
  class: "w-full bg-green-50 pt-1"
};
const _hoisted_11 = {
  class: "flex"
};
const _hoisted_12 = {
  class: "flex flex-row w-full"
};
const _hoisted_13 = {
  class: "w-3/12 px-2"
};
const _hoisted_14 = {
  class: "w-3/12 px-2"
};
const _hoisted_15 = {
  class: "w-3/12 px-2"
};
const _hoisted_16 = {
  class: "w-3/12 px-2"
};
const _hoisted_17 = {
  class: "p-1 bg-green-50 h-8"
};
const _hoisted_18 = {
  class: ""
};
const _hoisted_19 = {
  class: "flex justify-between"
};
const _hoisted_20 = {
  class: "px-4 py-2"
};
const _hoisted_21 = {
  key: 0
};
const _hoisted_22 = {
  key: 1
};
const _hoisted_23 = {
  key: 0
};
const _hoisted_24 = {
  class: "w-full py-2"
};
const _hoisted_25 = {
  class: "flex justify-between"
};
const _hoisted_26 = {
  class: "w-11/12 px-2"
};
const _hoisted_27 = {
  class: "pr-10 mb-2"
};
const _hoisted_28 = {
  class: "w-1/12 pr-1 self-center"
};
const _hoisted_29 = {
  class: ""
};
const _hoisted_30 = {
  key: 1,
  class: "px-6"
};
const _hoisted_31 = {
  key: 0,
  class: "text-center text-lg py-4"
};
const _hoisted_32 = {
  key: 1,
  class: ""
};
const _hoisted_33 = ["onClick"];
const _hoisted_34 = {
  key: 0,
  class: "underline"
};
const _hoisted_35 = ["onClick"];
const _hoisted_36 = {
  class: "font-semibold"
};
const _hoisted_37 = {
  key: 0,
  class: "uppercase"
};
const _hoisted_38 = {
  class: "expanded-detail-row"
};
const _hoisted_39 = {
  class: "font-semibold"
};
const _hoisted_40 = {
  class: "font-semibold"
};
const _hoisted_41 = {
  class: "font-semibold"
};
import { reactive, onMounted, onUnmounted, nextTick, computed, ref } from 'vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import { useInvoiceEmailActivityStore } from './useInvoiceEmailActivityStore.js';
import { useInvoiceEmailStore } from '../InvoiceEmail/useInvoiceEmailStore';
import MainHeader from '@/components/MainHeader.vue';
import LlSelect from '@/components/LlSelect.vue';
import LlDataTable from '@/components/LlDataTable.vue';
import StatusColorBar from './StatusColorBar.vue';
import { formatSentDate, getMessageType, getReminderNumber, getStatus, reminderRequest, remindersNotSentMessage } from './emailActivityFormat';
import { senderNameOrCompanyName } from '@/utils/senderNameValidation';
import Loader from '@/components/Loader.vue';
import LlDataTablePagination from '@/components/LlDataTablePagination.vue';
import UpdateSubject from '../InvoiceEmail/UpdateSubject.vue';
import UpdateIntro from '../InvoiceEmail/UpdateIntro.vue';
import ClientMatterSearch from '@/components/ClientMatterSearch.vue';
import StatusPaymentFilter from './StatusPaymentFilter.vue';
import MatterInvolvingFilter from '@/components/MatterInvolvingFilter.vue';
import DateRangeSelect from '@/components/DateRangeSelect.vue';
import RouteService from '@/services/RouteService';
import { roleHelpers } from '@/services/utils';
import { useExportUtilities } from '@/composables/useExportUtilities';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
import debounce from '@/components/shared/debounce';
export default {
  __name: 'EmailActivity',
  props: {
    alerts: {
      type: Object,
      required: true
    },
    tracking: {
      type: Object,
      required: false
    },
    userService: {
      type: Object,
      required: true
    },
    billingFilterService: {
      type: Object,
      required: true
    },
    // No longer read by this page - ClientMatterSearch fetches its own options.
    // Kept declared so the value the route still passes stays a prop rather than
    // falling through as an attribute on the root element.
    clientMatterManager: {
      type: Object,
      required: true
    },
    stateParams: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const hasFirmSettingsPermission = computed(() => {
      return emailsActivityState.me.access.setup;
    });
    const readyToSave = computed(() => {
      var settings = invoiceEmailStore.invoiceDelivery;
      return (settings.reminderBody?.length > 0 || emailsActivityState.reminderBody?.length > 0) && settings.reminderSubjectId;
    });
    const emailsActivityState = reactive({
      remindersReady: false,
      loading: false,
      enabled: null,
      offset: 0,
      limit: 20,
      count: 0,
      toggleShowFilters: false,
      currentPage: 1,
      invoiceEmailsActivityList: [],
      emailLogId: '',
      me: {},
      filter: {
        query: '',
        range: {
          range: {
            startDate: null,
            endDate: null
          }
        },
        // null rather than {}: ClientMatterSearch treats these as "nothing selected"
        // and assigns null when cleared, and an empty object reads as a selected
        // item with no id.
        cm: {
          client: null,
          matter: null
        },
        paymentStatus: {
          id: 'unPaid',
          label: 'Unpaid'
        },
        messageType: {
          id: '',
          label: 'All'
        },
        scope: 'involved',
        orderby: 'SentDate',
        sortAscending: false,
        search: ''
      },
      masks: {
        input: 'MM-DD-YYYY'
      },
      selectedEmails: [],
      reminderSubjectOptions: [],
      showIntroChangeOnHover: false,
      reminderMode: '1',
      reminderBody: undefined
    });
    const invoiceEmailActivityStore = useInvoiceEmailActivityStore();
    const invoiceEmailStore = useInvoiceEmailStore();
    invoiceEmailStore.alerts = props.alerts;
    invoiceEmailActivityStore.alerts = props.alerts;
    invoiceEmailActivityStore.$subscribe((mutation, storeState) => {
      emailsActivityState.loading = storeState.loading;
    });
    onMounted(async () => {
      const {
        cm,
        range,
        filter
      } = props.billingFilterService.state;
      const {
        scopeAccount
      } = filter || {};
      emailsActivityState.me = await props.userService.getMe();
      if (scopeAccount) {
        emailsActivityState.filter.scopeAccount = scopeAccount;
      } else if (!roleHelpers.isOperatorOrAccountantRole(emailsActivityState.me?.role)) {
        // Everyone else defaults to "matters involving me", consistent with the
        // rest of the product. Operators and Accountants aren't on matters, so
        // scoping them to themselves both hides records they should see and
        // forces the expensive scope path: a scopeAccount sends scope=involved,
        // which resolves to ClientMattersByAccountIdOR (joins MatterShares)
        // instead of ClientMattersByAccountId (doesn't). On a firm with a large
        // matter count that difference is seconds per page load.
        emailsActivityState.filter.scopeAccount = emailsActivityState.me;
      }
      emailsActivityState.filter.cm = cm || {
        client: null,
        matter: null
      };
      emailsActivityState.loading = true;
      try {
        // Independent of each other, and the table needs only the first. Running
        // them sequentially meant the email query didn't start until everything
        // ahead of it had finished. ClientMatterSearch loads its own options, so
        // the pickers are no longer on this path at all.
        await Promise.all([getInvoiceEmailsActivity(), getInvoiceDeliverySettings()]);
      } finally {
        // Without this, one failed request leaves the page spinning forever.
        emailsActivityState.loading = false;
      }
      var settings = invoiceEmailStore.invoiceDelivery;
      emailsActivityState.remindersReady = settings.reminderBody?.length > 0 && settings.reminderSubjectId;
    });
    onUnmounted(() => {
      // The Pinia store outlives this component, so leaving the page otherwise
      // keeps the whole result set - and every nested recipients/reminders array
      // Pinia has proxied - alive for the rest of the session. This also aborts
      // any request still running for a page nobody is looking at.
      handleSearchInput.cancel();
      invoiceEmailActivityStore.releaseInvoiceEmailsActivity();
      emailsActivityState.invoiceEmailsActivityList = [];
      emailsActivityState.selectedEmails = [];
    });
    async function getInvoiceDeliverySettings() {
      await invoiceEmailStore.getInvoiceDeliveryDetail();
      emailsActivityState.reminderSubjectOptions = invoiceEmailStore.getReminderSubjectOptions(emailsActivityState);
      invoiceEmailStore.reminderSubjectOptions = emailsActivityState.reminderSubjectOptions;
      const {
        reminderSubject,
        reminderBody,
        enabled
      } = invoiceEmailStore.invoiceDelivery;
      emailsActivityState.enabled = enabled;
      if (!reminderBody) {
        emailsActivityState.reminderBody = invoiceEmailStore.getDefaultReminderBody(emailsActivityState);
      } else {
        emailsActivityState.reminderBody = reminderBody;
      }
      if (reminderSubject) {
        invoiceEmailStore.invoiceDelivery.reminderSubjectId = reminderSubject;
        if (!emailsActivityState.reminderSubjectOptions.find(sub => sub.value === reminderSubject)) {
          emailsActivityState.customReminderSubject = reminderSubject;
          invoiceEmailStore.customReminderSubject = reminderSubject;
          emailsActivityState.reminderSubjectOptions.unshift({
            label: reminderSubject,
            value: reminderSubject
          });
        }
      }
    }
    async function getInvoiceEmailsActivity() {
      const routeService = new RouteService(props);
      emailsActivityState.emailLogId = routeService.params().emailLogId;
      let singleEmailLog = {};
      if (emailsActivityState.emailLogId && emailsActivityState.currentPage === 1) {
        singleEmailLog = await invoiceEmailActivityStore.getEmailLogsByID(emailsActivityState.emailLogId);
      }
      await invoiceEmailActivityStore.getInvoiceEmailsActivity(emailsActivityState.offset, emailsActivityState.limit, emailsActivityState.filter.query, emailsActivityState.filter.cm.client?.id, emailsActivityState.filter.cm.matter?.id, emailsActivityState.filter.paymentStatus, emailsActivityState.filter.messageType, emailsActivityState.filter.range?.range, emailsActivityState.filter.scopeAccount, emailsActivityState.filter.scope, emailsActivityState.filter.orderby, emailsActivityState.filter.sortAscending, emailsActivityState.filter.search);
      const {
        count,
        invoiceEmailsActivityList
      } = invoiceEmailActivityStore;
      emailsActivityState.invoiceEmailsActivityList = invoiceEmailsActivityList;
      if (Object.keys(singleEmailLog).length > 0) {
        emailsActivityState.invoiceEmailsActivityList = emailsActivityState.invoiceEmailsActivityList.filter(email => singleEmailLog.emailLogId !== email.emailLogId);
        singleEmailLog.selectedEmail = true;
        emailsActivityState.invoiceEmailsActivityList.unshift(singleEmailLog);
      }
      emailsActivityState.count = count;
    }
    const PAGE_SIZE_OPTIONS = [20, 50, 100];
    const {
      exportCSV
    } = useExportUtilities();
    const {
      handleError,
      handleSuccess
    } = useSnackbarHandler();
    const exporting = ref(false);

    /**
     * Exports every row matching the current filters, not just the page on screen.
     *
     * The rows are held in a local const, mapped straight to CSV strings and then
     * dropped - they never enter the Pinia store and are never rendered, so this
     * doesn't reintroduce the memory cost that made Show All unusable.
     */
    async function handleExport() {
      if (!emailsActivityState.count) return;
      exporting.value = true;
      try {
        const rows = await invoiceEmailActivityStore.fetchInvoiceEmailsForExport(emailsActivityState.count, emailsActivityState.filter.query, emailsActivityState.filter.cm.client?.id, emailsActivityState.filter.cm.matter?.id, emailsActivityState.filter.paymentStatus, emailsActivityState.filter.messageType, emailsActivityState.filter.range?.range, emailsActivityState.filter.scopeAccount, emailsActivityState.filter.scope, emailsActivityState.filter.orderby, emailsActivityState.filter.sortAscending, emailsActivityState.filter.search);

        // Same columns as the table, plus the recipient detail that's otherwise
        // only visible once a row is expanded.
        await exportCSV(rows, {
          Client: 'client',
          Message: 'message',
          From: 'fromEmail',
          Type: row => getMessageType(row),
          Recipients: row => (row.recipients || []).map(r => r.email).join('; '),
          'Recipient Count': row => (row.recipients || []).length,
          Status: row => getStatus(row),
          'Sent Date': row => formatSentDate(row.sentDate),
          Reminders: row => (row.reminders || []).length
        }, {
          filename: 'track-sent-emails'
        });
      } catch (error) {
        props.alerts.error(error?.response?.data?.message || 'Could not export these emails.');
      } finally {
        exporting.value = false;
      }
    }
    function onPageChange(page) {
      emailsActivityState.currentPage = page;
      emailsActivityState.offset = (page - 1) * emailsActivityState.limit;
      emailsActivityState.selectedEmails = [];
      getInvoiceEmailsActivity();
    }
    function onPageSizeChange(pageSize) {
      // Changing page size invalidates the current offset, so go back to page one
      // rather than landing somewhere arbitrary in the middle of the result set.
      emailsActivityState.limit = pageSize;
      emailsActivityState.currentPage = 1;
      emailsActivityState.offset = 0;
      emailsActivityState.selectedEmails = [];
      getInvoiceEmailsActivity();
    }
    function reminderSubjectChange() {
      nextTick(() => {
        if (invoiceEmailStore.invoiceDelivery.reminderSubjectId === 'custom') {
          invoiceEmailStore.toggleUpdateSubjectModal(invoiceEmailStore.customReminderSubject, emailsActivityState.reminderMode);
        }
      });
    }
    function introChange() {
      invoiceEmailStore.toggleUpdateIntroModal();
    }
    async function sendReminderEmails(isActive) {
      isActive.value = false;
      var updatedSettings = invoiceEmailStore.invoiceDelivery;
      updatedSettings.reminderBody = emailsActivityState.reminderBody;
      if (invoiceEmailStore.invoiceDelivery.reminderSubjectId === 'custom') {
        invoiceEmailStore.invoiceDelivery.reminderSubjectId = invoiceEmailStore.customReminderSubject;
      }
      updatedSettings.reminderSubject = updatedSettings.reminderSubjectId;
      updatedSettings.fromName = senderNameOrCompanyName(updatedSettings.fromName, emailsActivityState.me?.company?.name) ?? updatedSettings.fromName;
      // Reminders are built from the saved body and subject, so don't send them if this save was rejected.
      // The user is sending reminders, not editing settings, so the outcome reported is the reminders'.
      const saved = await invoiceEmailStore.sentInvoiceDeliveryDetail(updatedSettings, {
        notifySuccess: false
      });
      if (!saved) {
        return;
      }
      const emails = emailsActivityState.selectedEmails.map(id => emailsActivityState.invoiceEmailsActivityList.find(x => x.emailLogId === id));
      emailsActivityState.selectedEmails = [];
      const results = await Promise.allSettled(emails.map(original => invoiceEmailActivityStore.sendReminderEmail(reminderRequest(original))
      // Only after the server accepts it: a rejected reminder never went out.
      .then(() => addReminder(original))));
      const failures = results.flatMap(({
        status,
        reason
      }, i) => status === 'rejected' ? [{
        email: emails[i],
        error: reason
      }] : []);
      if (failures.length) {
        handleError(remindersNotSentMessage(failures));
      } else {
        handleSuccess(emails.length === 1 ? '1 reminder sent.' : `${emails.length} reminders sent.`);
      }
    }
    async function cancel(isActive) {
      isActive.value = false;
      emailsActivityState.selectedEmails = [];
    }
    async function addReminder(original) {
      if (original) {
        var recipients = original.recipients.map(({
          email,
          status
        }) => ({
          email,
          status: 'Sending'
        }));
        nextTick(() => {
          original.reminders.push({
            messageType: original?.messageType === 'trustRequestEmail' ? 'trustRequestReminderEmail' : 'invoiceReminderEmail',
            fromEmail: original.fromEmail,
            recipients: recipients,
            sentDate: new Date().toISOString(),
            message: 'Sending...',
            client: original.client,
            paid: false,
            customEmailId: original.customEmailId,
            timeSheetId: original.timeSheetId
          });
        });
      }
    }

    /**
     * Scope for the client/matter pickers, in the boolean shape ClientMatterSearch
     * wants. It loads and counts its own options, and above 200 it switches the
     * dropdowns to server-side search - so this page no longer downloads the firm's
     * clients and matters just to populate two autocompletes.
     *
     * `showSecondarySplitMatter` must be passed explicitly: the model defaults it to
     * true but the /matters/options and /clients/options endpoints both default the
     * query parameter to false, so leaving it out would quietly drop secondary split
     * matters from the pickers on this page.
     */
    const cmQueryFilter = computed(() => {
      const {
        autoAssign
      } = emailsActivityState.me?.permissions?.matters || {};
      const {
        scopeAccount,
        scope
      } = emailsActivityState.filter;

      // autoAssign users pick from every matter regardless of who the page is
      // scoped to, as they did before.
      if (autoAssign || !scopeAccount?.id) {
        return {
          scopeAccount: null,
          involved: false,
          primary: false,
          originating: false,
          reviewer: false,
          archived: false,
          showSecondarySplitMatter: true
        };
      }

      // MatterInvolvingFilter keeps `scope` as the source of truth: 'involved' when
      // no role checkbox is ticked, otherwise a comma-joined list of the ticked
      // ones. This is the same value the email query itself is filtered by.
      const scopes = (scope || 'involved').split(',');
      return {
        scopeAccount: scopeAccount.id,
        involved: scopes.includes('involved'),
        primary: scopes.includes('primary'),
        originating: scopes.includes('originating'),
        reviewer: scopes.includes('reviewer'),
        archived: false,
        showSecondarySplitMatter: true
      };
    });
    function scopeAccountChange(updatedForm) {
      emailsActivityState.selectedEmails = [];
      emailsActivityState.filter = updatedForm;

      // MatterInvolvingFilter component handles scope and checkbox resets internally

      // Changing who you're scoped to changes the result set, so page 3 of the old
      // set is meaningless. Every other filter on this page already does this.
      resetPagination();

      // Only the table is refreshed here. The pickers reload themselves off
      // cmQueryFilter, which recomputes from the scope this just assigned.
      getInvoiceEmailsActivity();
    }
    const handleSearchInput = debounce(() => filterChanged(), 1000);

    // Same columns, same order as the table this replaced. Widths match the old
    // <th> widths so the layout doesn't shift.
    const tableHeaders = [{
      title: 'Client',
      key: 'client',
      sortable: true,
      cellProps: {
        'data-cy': 'email-clientName'
      }
    }, {
      title: 'Message',
      key: 'message',
      sortable: false
    }, {
      title: 'From',
      key: 'fromEmail',
      sortable: false,
      cellProps: {
        'data-cy': 'from-email'
      }
    }, {
      title: 'Type',
      key: 'type',
      sortable: false,
      width: '100px'
    }, {
      title: 'To',
      key: 'recipients',
      sortable: false,
      width: '300px'
    }, {
      title: 'Status',
      key: 'status',
      sortable: false,
      width: '75px'
    }, {
      title: 'Sent Date',
      key: 'sentDate',
      sortable: true
    }];

    // Preserves the old row tinting: paid invoices green, the row deep-linked to
    // via ?emailLogId yellow.
    const rowProps = ({
      item
    }) => ({
      'data-cy': 'email-logs',
      class: {
        'bg-green-50': item.paid,
        'bg-yellow-50': item.selectedEmail
      }
    });

    // Inline expansion, driven from the Type and Recipients cells rather than a
    // chevron column, so the column set stays exactly as it was.
    const expandedRows = ref([]);
    function toggleExpand(email) {
      const id = email.emailLogId;
      expandedRows.value = expandedRows.value.includes(id) ? expandedRows.value.filter(x => x !== id) : [...expandedRows.value, id];
    }

    // LlDataTable speaks Vuetify's [{ key, order }]; the API speaks
    // orderby/sortAscending. Only Client and Sent Date are sortable server-side.
    const SORT_KEY_TO_FIELD = {
      client: 'ClientName',
      sentDate: 'SentDate'
    };
    const tableSortBy = computed(() => [{
      key: emailsActivityState.filter.orderby === 'ClientName' ? 'client' : 'sentDate',
      order: emailsActivityState.filter.sortAscending ? 'asc' : 'desc'
    }]);
    function onSortBy(sortBy) {
      const next = sortBy?.[0];
      if (!next || !SORT_KEY_TO_FIELD[next.key]) return;
      emailsActivityState.filter.orderby = SORT_KEY_TO_FIELD[next.key];
      emailsActivityState.filter.sortAscending = next.order === 'asc';
      emailsActivityState.selectedEmails = [];
      // Re-sorting reorders the whole result set, so the current offset no longer
      // means anything - go back to page one. The old sort() didn't, which left
      // you on page 3 of a list that had just been reordered underneath you.
      resetPagination();
      getInvoiceEmailsActivity();
    }
    const dateRangeFilterChanged = dateSelect => {
      emailsActivityState.filter.range.range = dateSelect;
      filterChanged();
    };
    async function filterChanged(event) {
      resetPagination();
      if (event?.custom) {
        invoiceEmailActivityStore.loading = false;
      }
      emailsActivityState.selectedEmails = [];
      getInvoiceEmailsActivity();
    }

    // select-all, the indeterminate state and the master checkbox are all owned by
    // LlDataTable's show-select now, so the hand-rolled bookkeeping that used to
    // live here is gone.

    function resetPagination() {
      // Genuinely go back to page one. The previous version left `offset` pointing
      // at the page you were on while setting currentPage to 1, so after filtering
      // from page 3 you saw page-3 rows labelled page 1. It also forced the page
      // size back to 20, discarding the size the user had chosen.
      emailsActivityState.offset = 0;
      emailsActivityState.currentPage = 1;
    }
    return (_ctx, _cache) => {
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_spacer = _resolveComponent("v-spacer");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_dialog = _resolveComponent("v-dialog");
      return _openBlock(), _createElementBlock("div", null, [emailsActivityState.enabled === false && !emailsActivityState.me?.company?.settings?.gravity?.enabled ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[13] || (_cache[13] = _createStaticVNode("<span style=\"font-size:2.25rem;line-height:1.5;\" class=\"font-semibold py-4\" data-v-0017a1a4> Increase collections with LeanLaw Payments </span><div class=\"max-w-screen-sm text-xl pt-4\" data-v-0017a1a4><p class=\"py-2\" data-v-0017a1a4><strong data-v-0017a1a4>Imagine if your clients paid 100% of invoices, online, within 5 days.</strong></p><p class=\"py-2\" data-v-0017a1a4><span style=\"font-weight:400;\" data-v-0017a1a4>LeanLaw’s electronic and automated payment system helps law firms collect more, collect faster, and collect at a lower cost.</span></p></div>", 2)), _createElementVNode("div", _hoisted_3, [_createVNode(LlSecondaryButton, {
        variant: "outlined",
        color: "primary",
        class: "my-4 no-underline hover:no-underline",
        href: "https://www.leanlaw.co/features/leanlaw-payments/",
        target: "_blank",
        rel: "noopener noreferrer"
      }, {
        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode(" Learn More ", -1)]))]),
        _: 1
      })])]), _cache[14] || (_cache[14] = _createElementVNode("div", {
        class: "lg:w-6/12 sm:w-full md:w-full pl-4",
        style: {
          "margin-top": "-7px",
          "margin-right": "0px"
        }
      }, [_createElementVNode("div", {
        class: "w-full pt-8 lg:h-5/6 xl:h-full payments-demo-bl-lg mb-6"
      }, [_createElementVNode("img", {
        src: _imports_0
      })])], -1))])) : _createCommentVNode("", true), emailsActivityState.enabled || emailsActivityState.me?.company?.settings?.gravity?.enabled ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", null, [_createVNode(MainHeader, {
        content: 'Track Sent Emails',
        isBillingPageTitle: true
      }), _cache[15] || (_cache[15] = _createElementVNode("div", {
        class: "text-sm text-gray-800 bg-white"
      }, null, -1))])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_cache[16] || (_cache[16] = _createElementVNode("div", {
        class: "flex absolute inset-y-0 left-0 items-center pt-1 pl-3 pointer-events-none",
        "aria-hidden": "true"
      }, [_createElementVNode("svg", {
        class: "mr-3 w-4 h-4 text-gray-400",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true"
      }, [_createElementVNode("path", {
        "fill-rule": "evenodd",
        d: "M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z",
        "clip-rule": "evenodd"
      })])], -1)), _withDirectives(_createElementVNode("input", {
        type: "search",
        name: "search",
        id: "search",
        class: "block w-full",
        style: {
          "width": "100%"
        },
        placeholder: "Search...",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => emailsActivityState.filter.search = $event),
        onInput: _cache[1] || (_cache[1] = $event => _unref(handleSearchInput)())
      }, null, 544), [[_vModelText, emailsActivityState.filter.search]])])])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_withDirectives(_createElementVNode("div", _hoisted_11, [...(_cache[17] || (_cache[17] = [_createStaticVNode("<span class=\"pt-1 pl-2\" data-v-0017a1a4><svg xmlns=\"http://www.w3.org/2000/svg\" height=\"24px\" viewBox=\"0 0 24 24\" width=\"24px\" fill=\"#000000\" data-v-0017a1a4><path d=\"M0 0h24v24H0V0z\" fill=\"none\" data-v-0017a1a4></path><path d=\"M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z\" data-v-0017a1a4></path></svg></span><span class=\"text-base p-1\" data-v-0017a1a4>Filters</span>", 2)]))], 512), [[_vShow, emailsActivityState.toggleShowFilters]]), _withDirectives(_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createVNode(DateRangeSelect, {
        "default-range": 'Original Sent Date',
        onDateRangeFilter: dateRangeFilterChanged
      })]), _createElementVNode("div", _hoisted_14, [_createVNode(StatusPaymentFilter, {
        form: emailsActivityState.filter,
        onStatusChange: _cache[2] || (_cache[2] = $event => filterChanged())
      }, null, 8, ["form"])]), _createElementVNode("div", _hoisted_15, [_createVNode(ClientMatterSearch, {
        cm: emailsActivityState.filter.cm,
        "query-filter": cmQueryFilter.value,
        horizontal: true,
        emitOnAnyChange: true,
        onMatterChange: _cache[3] || (_cache[3] = $event => filterChanged())
      }, null, 8, ["cm", "query-filter"])]), _createElementVNode("div", _hoisted_16, [_createVNode(MatterInvolvingFilter, {
        form: emailsActivityState.filter,
        onMatterInvolvingChange: scopeAccountChange
      }, null, 8, ["form"])])], 512), [[_vShow, !emailsActivityState.toggleShowFilters]])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", {
        onClick: _cache[4] || (_cache[4] = _withModifiers($event => emailsActivityState.toggleShowFilters = !emailsActivityState.toggleShowFilters, ["prevent"]))
      }, [_withDirectives(_createElementVNode("span", null, [...(_cache[18] || (_cache[18] = [_createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "24px",
        viewBox: "0 0 24 24",
        width: "24px",
        fill: "#000000"
      }, [_createElementVNode("path", {
        d: "M0 0h24v24H0V0z",
        fill: "none"
      }), _createElementVNode("path", {
        d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14l-6-6z"
      })], -1)]))], 512), [[_vShow, !emailsActivityState.toggleShowFilters]]), _withDirectives(_createElementVNode("span", null, [...(_cache[19] || (_cache[19] = [_createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "24px",
        viewBox: "0 0 24 24",
        width: "24px",
        fill: "#000000"
      }, [_createElementVNode("path", {
        d: "M0 0h24v24H0V0z",
        fill: "none"
      }), _createElementVNode("path", {
        d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
      })], -1)]))], 512), [[_vShow, emailsActivityState.toggleShowFilters]])])])]), _createElementVNode("div", _hoisted_18, [_withDirectives(_createElementVNode("div", null, [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createTextVNode(_toDisplayString(emailsActivityState.selectedEmails.length) + " " + _toDisplayString(emailsActivityState.selectedEmails.length > 1 ? 'items' : 'item') + " selected ", 1), _createVNode(_component_v_dialog, {
        width: "800px !important"
      }, {
        activator: _withCtx(({
          props
        }) => [_createVNode(LlSecondaryButton, _mergeProps(props, {
          color: "primary",
          class: "m-3",
          disabled: emailsActivityState.selectedEmails.length == 0
        }), {
          default: _withCtx(() => [...(_cache[20] || (_cache[20] = [_createTextVNode("Send Reminder", -1)]))]),
          _: 1
        }, 16, ["disabled"])]),
        default: _withCtx(({
          isActive
        }) => [_createVNode(_component_v_card, {
          title: "Send Reminders"
        }, {
          default: _withCtx(() => [emailsActivityState.remindersReady ? (_openBlock(), _createBlock(_component_v_card_text, {
            key: 0
          }, {
            default: _withCtx(() => [_createTextVNode(" Send a reminder for " + _toDisplayString(emailsActivityState.selectedEmails.length) + " selected message" + _toDisplayString(emailsActivityState.selectedEmails.length > 1 ? '(s)' : ''), 1)]),
            _: 1
          })) : (_openBlock(), _createBlock(_component_v_card_text, {
            key: 1
          }, {
            default: _withCtx(() => [_cache[23] || (_cache[23] = _createTextVNode(" Hey it looks like your firm hasn't configured your reminder template under Email Settings. ", -1)), !hasFirmSettingsPermission.value ? (_openBlock(), _createElementBlock("span", _hoisted_21, " Ask your firm administrator to set that up before you send your first reminder! ")) : _createCommentVNode("", true), _cache[24] || (_cache[24] = _createTextVNode(" Please contact our support team if you have any issues. ", -1)), hasFirmSettingsPermission.value ? (_openBlock(), _createElementBlock("div", _hoisted_22, [!_unref(invoiceEmailStore).showUpdateSubjectModal ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_cache[21] || (_cache[21] = _createElementVNode("span", {
              class: "block font-bold text-base py-2"
            }, "Reminder Subject:", -1)), _createElementVNode("div", _hoisted_24, [_createVNode(LlSelect, {
              modelValue: _unref(invoiceEmailStore).invoiceDelivery.reminderSubjectId,
              "onUpdate:modelValue": [_cache[5] || (_cache[5] = $event => _unref(invoiceEmailStore).invoiceDelivery.reminderSubjectId = $event), _cache[6] || (_cache[6] = $event => reminderSubjectChange())],
              items: emailsActivityState.reminderSubjectOptions,
              "item-value": "value",
              "return-object": false,
              placeholder: "Pick Reminder Subject",
              class: "mb-0",
              clearable: false,
              "hide-details": true
            }, null, 8, ["modelValue", "items"])])])) : _createCommentVNode("", true), _unref(invoiceEmailStore).showUpdateSubjectModal ? (_openBlock(), _createBlock(UpdateSubject, {
              key: 1,
              reminderMode: emailsActivityState.reminderMode,
              alerts: __props.alerts
            }, null, 8, ["reminderMode", "alerts"])) : _createCommentVNode("", true), !_unref(invoiceEmailStore).showUpdateIntroModal ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(["rounded border-gray-400 mt-2 py-2 pl-10 cursor-pointer bg-white", {
                'border-2 border-[rgb(var(--v-theme-primary))]': emailsActivityState.showIntroChangeOnHover
              }]),
              onMouseover: _cache[7] || (_cache[7] = $event => emailsActivityState.showIntroChangeOnHover = true),
              onMouseleave: _cache[8] || (_cache[8] = $event => emailsActivityState.showIntroChangeOnHover = false),
              onClick: _cache[9] || (_cache[9] = _withModifiers($event => introChange(), ["prevent"]))
            }, [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("pre", _hoisted_27, _toDisplayString(emailsActivityState.reminderBody), 1)]), _createElementVNode("div", _hoisted_28, [_withDirectives(_createElementVNode("div", _hoisted_29, [...(_cache[22] || (_cache[22] = [_createElementVNode("span", {
              class: "text-gray-100 text-xs"
            }, [_createElementVNode("span", {
              class: "fa fa-pencil text-lg text-primary"
            })], -1)]))], 512), [[_vShow, emailsActivityState.showIntroChangeOnHover]])])])], 34)) : _createCommentVNode("", true), _unref(invoiceEmailStore).showUpdateIntroModal ? (_openBlock(), _createBlock(UpdateIntro, {
              key: 3,
              state: emailsActivityState,
              alerts: __props.alerts
            }, null, 8, ["state", "alerts"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]),
            _: 1
          })), _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [_createVNode(_component_v_spacer), _createVNode(LlSecondaryButton, {
              onClick: $event => cancel(isActive)
            }, {
              default: _withCtx(() => [...(_cache[25] || (_cache[25] = [_createTextVNode(" Cancel ", -1)]))]),
              _: 1
            }, 8, ["onClick"]), _createVNode(LlSecondaryButton, {
              color: "primary",
              disabled: !readyToSave.value || _unref(invoiceEmailStore).showUpdateIntroModal,
              class: "m-3",
              onClick: $event => sendReminderEmails(isActive)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(emailsActivityState.remindersReady ? 'Send' : 'Save and Send'), 1)]),
              _: 1
            }, 8, ["disabled", "onClick"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024)]),
        _: 1
      }), _createVNode(LlSecondaryButton, {
        class: "m-3",
        variant: "outlined",
        disabled: exporting.value || !emailsActivityState.count,
        loading: exporting.value,
        onClick: handleExport
      }, {
        default: _withCtx(() => [...(_cache[26] || (_cache[26] = [_createTextVNode(" Export ", -1)]))]),
        _: 1
      }, 8, ["disabled", "loading"])]), emailsActivityState.enabled && emailsActivityState.me?.company?.settings?.gravity?.enabled && emailsActivityState.invoiceEmailsActivityList.length > 0 && !emailsActivityState.loading ? (_openBlock(), _createBlock(LlDataTablePagination, {
        key: 0,
        class: "print:hidden",
        page: emailsActivityState.currentPage,
        "page-size": emailsActivityState.limit,
        "total-count": emailsActivityState.count,
        "page-size-options": PAGE_SIZE_OPTIONS,
        "onUpdate:page": onPageChange,
        "onUpdate:pageSize": onPageSizeChange
      }, null, 8, ["page", "page-size", "total-count"])) : _createCommentVNode("", true)])], 512), [[_vShow, !emailsActivityState.loading]])])])) : _createCommentVNode("", true), _createElementVNode("div", null, [emailsActivityState.loading ? (_openBlock(), _createBlock(Loader, {
        key: 0,
        what: 'Track Sent Emails',
        class: "mt-32"
      })) : (_openBlock(), _createElementBlock("div", _hoisted_30, [_withDirectives(_createElementVNode("div", null, [!emailsActivityState.invoiceEmailsActivityList.length && !emailsActivityState.loading ? (_openBlock(), _createElementBlock("div", _hoisted_31, " No emails match the filters set. ")) : (_openBlock(), _createElementBlock("div", _hoisted_32, [_createVNode(LlDataTable, {
        "data-cy": "email-activity-table",
        headers: tableHeaders,
        items: emailsActivityState.invoiceEmailsActivityList,
        "items-length": emailsActivityState.count,
        "sort-by": tableSortBy.value,
        "model-value": emailsActivityState.selectedEmails,
        "row-props": rowProps,
        expanded: expandedRows.value,
        "item-value": "emailLogId",
        "show-select": "",
        "onUpdate:sortBy": onSortBy,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => emailsActivityState.selectedEmails = $event),
        "onUpdate:expanded": _cache[11] || (_cache[11] = $event => expandedRows.value = $event)
      }, {
        [`item.type`]: _withCtx(({
          item
        }) => [_createElementVNode("button", {
          type: "button",
          class: "font-semibold text-left",
          onClick: $event => toggleExpand(item)
        }, [_createTextVNode(_toDisplayString(_unref(getMessageType)(item)) + " ", 1), item.reminders?.length ? (_openBlock(), _createElementBlock("span", _hoisted_34, " (+" + _toDisplayString(item.reminders.length) + " more) ", 1)) : _createCommentVNode("", true)], 8, _hoisted_33)]),
        [`item.recipients`]: _withCtx(({
          item
        }) => [_createElementVNode("button", {
          type: "button",
          class: "font-semibold text-left",
          onClick: $event => toggleExpand(item)
        }, _toDisplayString(item.recipients?.length || 0) + " Recipients ", 9, _hoisted_35)]),
        [`item.status`]: _withCtx(({
          item
        }) => [_createVNode(StatusColorBar, {
          status: _unref(getStatus)(item)
        }, null, 8, ["status"])]),
        [`item.sentDate`]: _withCtx(({
          item
        }) => [_createTextVNode(_toDisplayString(_unref(formatSentDate)(item.sentDate)), 1)]),
        "expanded-row": _withCtx(({
          item
        }) => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.recipients, (to, toId) => {
          return _openBlock(), _createElementBlock("tr", {
            key: `to-${toId}`,
            class: "expanded-detail-row"
          }, [_cache[27] || (_cache[27] = _createElementVNode("td", {
            colspan: "4"
          }, null, -1)), _cache[28] || (_cache[28] = _createElementVNode("td", null, null, -1)), _createElementVNode("td", null, [_createElementVNode("span", _hoisted_36, _toDisplayString(to.email), 1)]), _createElementVNode("td", null, [item.paid ? (_openBlock(), _createElementBlock("span", _hoisted_37, "paid")) : (_openBlock(), _createBlock(StatusColorBar, {
            key: 1,
            status: to.status
          }, null, 8, ["status"]))]), _cache[29] || (_cache[29] = _createElementVNode("td", null, null, -1))]);
        }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.reminders, reminder => {
          return _openBlock(), _createElementBlock(_Fragment, {
            key: reminder.emailLogId
          }, [_createElementVNode("tr", _hoisted_38, [_cache[30] || (_cache[30] = _createElementVNode("td", {
            colspan: "4"
          }, null, -1)), _createElementVNode("td", _hoisted_39, _toDisplayString(_unref(getMessageType)(reminder, _unref(getReminderNumber)(item.reminders, reminder.emailLogId, reminder.messageType))), 1), _createElementVNode("td", _hoisted_40, _toDisplayString(reminder.recipients?.length || 0) + " Recipients ", 1), _createElementVNode("td", null, [_createVNode(StatusColorBar, {
            status: _unref(getStatus)(reminder)
          }, null, 8, ["status"])]), _createElementVNode("td", null, _toDisplayString(_unref(formatSentDate)(reminder.sentDate)), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reminder.recipients, (to, toId) => {
            return _openBlock(), _createElementBlock("tr", {
              key: `${reminder.emailLogId}-${toId}`,
              class: "expanded-detail-row"
            }, [_cache[31] || (_cache[31] = _createElementVNode("td", {
              colspan: "4"
            }, null, -1)), _cache[32] || (_cache[32] = _createElementVNode("td", null, null, -1)), _createElementVNode("td", null, [_createElementVNode("span", _hoisted_41, _toDisplayString(to.email), 1)]), _createElementVNode("td", null, [_createVNode(StatusColorBar, {
              status: to.status
            }, null, 8, ["status"])]), _cache[33] || (_cache[33] = _createElementVNode("td", null, null, -1))]);
          }), 128))], 64);
        }), 128))]),
        _: 2
      }, 1032, ["items", "items-length", "sort-by", "model-value", "expanded"])]))], 512), [[_vShow, emailsActivityState.enabled || emailsActivityState.me?.company?.settings?.gravity?.enabled]])])), (emailsActivityState.enabled || emailsActivityState.me?.company?.settings?.gravity?.enabled) && emailsActivityState.invoiceEmailsActivityList.length > 0 && !emailsActivityState.loading ? (_openBlock(), _createBlock(LlDataTablePagination, {
        key: 2,
        class: "print:hidden",
        page: emailsActivityState.currentPage,
        "page-size": emailsActivityState.limit,
        "total-count": emailsActivityState.count,
        "page-size-options": PAGE_SIZE_OPTIONS,
        "onUpdate:page": onPageChange,
        "onUpdate:pageSize": onPageSizeChange
      }, null, 8, ["page", "page-size", "total-count"])) : _createCommentVNode("", true)])]);
    };
  }
};